var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14941 16.9361L4.48041 13.8707C3.46213 12.4252 3.00637 10.6578 3.19866 8.90015C3.39095 7.14248 4.21807 5.5154 5.52481 4.32426C6.83155 3.13312 8.52807 2.45981 10.296 2.43067C12.0639 2.40154 13.7817 3.0186 15.1269 4.16603C16.4722 5.31347 17.3525 6.91242 17.6026 8.66279C17.8527 10.4132 17.4554 12.1947 16.4853 13.6729C15.5152 15.1512 14.039 16.2246 12.3336 16.6917C10.6283 17.1589 8.81111 16.9876 7.22308 16.2101L3.14941 16.9361Z",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98926 8.06156C7.98926 8.16853 8.03175 8.27112 8.10739 8.34676C8.18303 8.4224 8.28562 8.4649 8.39259 8.4649C8.49956 8.4649 8.60215 8.4224 8.67779 8.34676C8.75343 8.27112 8.79592 8.16853 8.79592 8.06156V7.2549C8.79592 7.14793 8.75343 7.04534 8.67779 6.9697C8.60215 6.89406 8.49956 6.85156 8.39259 6.85156C8.28562 6.85156 8.18303 6.89406 8.10739 6.9697C8.03175 7.04534 7.98926 7.14793 7.98926 7.2549V8.06156ZM7.98926 8.06156C7.98926 9.13127 8.4142 10.1572 9.17059 10.9136C9.92699 11.67 10.9529 12.0949 12.0226 12.0949M12.0226 12.0949H12.8293C12.9362 12.0949 13.0388 12.0524 13.1145 11.9768C13.1901 11.9011 13.2326 11.7985 13.2326 11.6916C13.2326 11.5846 13.1901 11.482 13.1145 11.4064C13.0388 11.3307 12.9362 11.2882 12.8293 11.2882H12.0226C11.9156 11.2882 11.813 11.3307 11.7374 11.4064C11.6618 11.482 11.6193 11.5846 11.6193 11.6916C11.6193 11.7985 11.6618 11.9011 11.7374 11.9768C11.813 12.0524 11.9156 12.0949 12.0226 12.0949Z",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.36,
    height: 19.36,
    fill: "white",
    transform: "translate(0.729492 -0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.84da28e3d91a8fe81362c05385d076fa.svg";
export { ForwardRef as ReactComponent };